<div class="position-relative">
  <div [style.max-height]="contentMaxHeight" class="overflow-hidden">
    <ng-content></ng-content>
  </div>
  @if (limitExceeded && !extended) {
    <div class="position-absolute fade-overlay"></div>
  }
</div>
@if (limitExceeded) {
  <div>
    @if (showMoreOption) {
      <span
        (click)="toggleExtend()"
        (keydown)="toggleExtend()"
        [id]="generateId()"
        class="btn btn-link p-0 m-0"
        tabindex="0"
        >{{ (extended ? 'common.less' : 'common.more') | cxTranslate }}</span
      >
    }
  </div>
}
